import * as tslib_1 from "tslib";
import "es6-promise";
import "intl";
import "intl/locale-data/jsonp/en";
import "intl/locale-data/jsonp/fi";
import { Vue, Component } from "vue-property-decorator";
import VueI18n from "vue-i18n";
import client from "client";
import blinkenlights from "blinkenlights";
import messages from "i18n";
import moment from "moment";
import "components";
Vue.use(VueI18n);
var dateTimeFormats = {
    date: {
        day: "numeric",
        month: "numeric",
        year: "numeric",
    },
    hourMinute: {
        hour: "numeric",
        minute: "2-digit",
        hour12: false
    },
    hour: {
        hour: "numeric",
        hour12: false
    },
    minute: {
        minute: "2-digit",
    }
};
var OtRoot = /** @class */ (function (_super) {
    tslib_1.__extends(OtRoot, _super);
    function OtRoot() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.client = client;
        _this.errorMessage = null;
        _this.errorTimer = null;
        return _this;
    }
    OtRoot.prototype.created = function () {
        var _this = this;
        moment.locale(this.$i18n.locale);
        blinkenlights.set({ r: 0, g: 0, b: 0 });
        client.onError = function (error) {
            _this.errorMessage = error;
            window.clearTimeout(_this.errorTimer);
            _this.errorTimer = window.setTimeout(function () {
                _this.errorMessage = null;
            }, 10000);
        };
    };
    OtRoot = tslib_1.__decorate([
        Component({
            i18n: new VueI18n({
                locale: "fi",
                fallbackLocale: "en",
                dateTimeFormats: {
                    "en": dateTimeFormats,
                    "fi": dateTimeFormats,
                },
                messages: messages,
            })
        })
    ], OtRoot);
    return OtRoot;
}(Vue));
export default OtRoot;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./app/ts/components/OtRoot.vue
// module id = 224
// module chunks = 0